import { render } from "./declare-page.vue?vue&type=template&id=0785b12b&scoped=true"
import script from "./declare-page.vue?vue&type=script&lang=js"
export * from "./declare-page.vue?vue&type=script&lang=js"

import "./declare-page.vue?vue&type=style&index=0&id=0785b12b&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/thinkcloud/thinkcloud-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0785b12b"]])

export default __exports__